import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { postImage } from '../../services/api-auto';
import styles from './styles.module.scss';

const ButtonsImagesCampain = ({
  smallText,
  texto,
  width,
  height,
  image,
  blob,
  widthMM,
  heightMM,
  changeImage,
  obterLink = false,
  disabled = false,
}) => {
  const ref = useRef();
  const [error, setError] = useState('');

  const onImageChange = (event, name) => {
    let img, file;
    setError('');
    if (event.target.files && event.target.files[0]) {
      file = event.target.files[0];
      if (
        file.type === 'image/png' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/png'
      ) {
        img = new Image();
        img.onload = async function () {
          // if (obterLink) {
          //     var link = await postImage(file);
          //     changeImage(link.data);
          // }
          // else {
          //     changeImage(file);
          // }
          if (
            this.width === parseInt(width) &&
            this.height === parseInt(height)
          ) {
            if (obterLink) {
              var link = await postImage(file);
              changeImage(link.data);
            } else {
              changeImage(file);
            }
          } else {
            setError(
              `Favor escolher imagens com dimensões ${width} x ${height}`
            );
          }
        };
        img.onerror = function () {
          alert('not a valid file: ' + file.type);
        };
        img.src = URL.createObjectURL(file);
        //changeImage(URL.createObjectURL(img))
      } else {
        setError(
          'Favor escolher imagens nos seguintes formatos: PNG, JPG ou JPEG'
        );
      }
    }
  };

  const callImageInput = () => {
    ref.current.click();
  };

  return (
    <div className={styles.imageWrapper}>
      <div className={styles.displayWrapper}>
        {image && obterLink && <img src={image} className={styles.display} />}
        {image && !obterLink && (
          <img src={URL.createObjectURL(image)} className={styles.display} />
        )}
        {!image && blob && (
          <img src={URL.createObjectURL(blob)} className={styles.display} />
        )}
      </div>
      <input
        type="file"
        onChange={onImageChange}
        style={{ display: 'none' }}
        ref={ref}
      />
      <button
        onClick={callImageInput}
        disabled={disabled}
        style={{ background: disabled ? '#e2e2e2' : '#ff000000' }}
      >
        <div className={styles.imageWrapperIcon}>
          <FontAwesomeIcon icon={faUpload} />
        </div>
        <div className={styles.imageButtonWrapperText}>
          <div className={styles.imageWrapperTexto}>
            <small>
              {smallText ? (
                <>
                  {smallText} <br />
                </>
              ) : (
                ''
              )}
            </small>
            {texto}
          </div>
        </div>
      </button>
      {error && <div className={styles.messageError}>{error}</div>}
      <div className={styles.imageWrapperDetalhes}>
        {' '}
        Formatos: PNG, JPG e JPEG{' '}
      </div>
      <div className={styles.imageWrapperDetalhes}>
        {' '}
        Dimensões: {`${width}px x ${height}px (${widthMM}mm x ${heightMM}mm)`}{' '}
      </div>
    </div>
  );
};

export default ButtonsImagesCampain;
